import React from "react";
import ReactDOM from "react-dom";
import { Authenticator } from "@aws-amplify/ui-react";
import { SnackbarProvider } from "notistack";

import { GlobalStyle } from "./shared/styles";
import { Config } from "shared/utils";
import {
  amplifyConfig,
  appSyncSettings,
  authenticatorConfig,
} from "shared/amplify.config";
import { AuthState } from "shared/interfaces/amplify.interface";
import "@aws-amplify/ui-react/styles.css";
import { ThemeProvider } from "@aws-amplify/ui-react";
import * as serviceWorker from "./serviceWorker";
import App from "App";

const Guard = ({ authState }: { authState?: AuthState }) => {
  return (
    <SnackbarProvider>
      <ThemeProvider>
        <App />
        {/* You can add your custom theme here if needed */}
      </ThemeProvider>
    </SnackbarProvider>
  );
};

const CognitoBoilerplate = () => {
  return (
    <React.StrictMode>
      <GlobalStyle />
      <Authenticator
        {...authenticatorConfig}
        components={{
          SignUp: {
            FormFields: () => null, // Remove form fields if someone still reaches Sign Up
            Footer: () => null,
          },
        }}
      >
        <Guard />
      </Authenticator>
    </React.StrictMode>
  );
};

// Wait for Amplify configuration apply
(async () => {
  await Config.getInstance().init(amplifyConfig, appSyncSettings);
  ReactDOM.render(<CognitoBoilerplate />, document.getElementById("root"));
})();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
